<template>
  <div class="input">
    <div class="input-group">
      <div class="button-pager" @click="routing(backQuiz)">
        まえへ
      </div>

      <div class="button-pager" @click="routing(nextQuiz)">
        つぎへ
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    backQuiz: function () {
      return this.$store.state.quiz.backQuiz
    },

    nextQuiz: function () {
      return this.$store.state.quiz.nextQuiz
    },
  },

  methods: {
    routing: function (quiz) {
      if (!quiz) {
        return
      }

      // TODO 取り急ぎの実装 現在のURLを書き換え
      this.$router.replace({
        name: 'quizset-quiz-edit',
        params: {
          quizsetId: this.$route.params.quizsetId,
          id: quiz.id,
        },
      })

      // TODO 取り急ぎの実装 直アクセス
      window.location.reload()
    },
  },
}
</script>

<style lang="scss" scoped>
.button-pager {
  @include button-ol-warning;
}
</style>
